import React from "react";
import { Container } from "react-bootstrap";
import "./Team.css";
const Team = () => {
  return (
    <div className="section-container team-container">
      <div className="section-heading text-center">
        <span>Our Teams</span>
        <h2>Meet Our teams</h2>
      </div>
      <Container>
        <div className="row">
          <div className="col-12 col-md-4 py-2">
            <div className="team-container">
              <img
                src={require("../../../images/team/team1.png")}
                alt=""
                className="w-100 h-100"
              />
              <div className="team-text p-2">
                <h4 className="fw-light m-0">John Doe</h4>
                <span>CEO,Gen Apparel</span>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-4 py-2">
            <div className="team-container">
              <img
                src={require("../../../images/team/team2.png")}
                alt=""
                className="w-100 h-100"
              />
            </div>
            <div className="team-text p-2">
            <h4 className="fw-light m-0">Marry Ann</h4>
            <span>CEO,Gen Apparel</span>
            </div>
          </div>
          <div className="col-12 col-md-4 py-2">
            <div className="team-container">
              <img
                src={require("../../../images/team/team3.png")}
                alt=""
                className="w-100 h-100"
              />
            </div>
            <div className="team-text p-2">
            <h4 className="fw-light m-0">Alita Angel</h4>
            <span>CEO,Gen Apparel</span>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Team;
